module.exports = __webpack_public_path__ + "img/dialog-img1.c2466cd5.png";